import { createAsyncThunk } from '@reduxjs/toolkit';
import { toastHandler } from '../../../utils/toastHandler';
import { axiosInstance } from '../../../client';

export const findSelectAffiliateGroup = createAsyncThunk(
  'selectAffiliateGroup/findSelectAffiliateGroup',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('user/affiliate-group');

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
